import React, { useState, useEffect } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import Loader from "../../../../components/Common/Loader";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
// import { GET_PIN_BY_ID } from "../../../../services/ApiCalls";

const PinDetail = () => {
  const [pinDetail, setPinDetail] = useState(null);
  const [loader, setLoader] = useState(false);
  const { id } = useParams();

  const getData = catchAsync(async () => {
    setLoader(true);
    // const res = await GET_PIN_BY_ID(id);
    // For now mocking API response:
    const res = {
      data: {
        status: "success",
        data: {
          _id: id,
          pin: "12345",
          country: "Thailand",
          state: "Bangkok",
          city: "Huai Khwang",
          address: "9609 Parkway East, Bangkok",
          assignTo: ["Mango Hotel", "Ashdan Hotel"],
          status: "active",
          description: "Important PIN zone for Bangkok hotels.",
          createdAt: "2025-02-01T10:00:00Z",
          updatedAt: "2025-02-10T15:30:00Z",
        },
      },
    };

    checkResponse({
      res,
      setData: setPinDetail,
      setLoader,
    });
  });

  useEffect(() => {
    if (id) getData();
  }, [id]);

  return (
    <>
      {loader && <Loader />}
      <section className="pinDetail py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/pin"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  Pin Details
                </h4>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div
                className="formWrapper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                <Row className="justify-content-between">
                  {/* Left Column */}
                  <Col md={6} className="my-2">
                    <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">PIN:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {pinDetail?.pin}
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">Country:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {pinDetail?.country}
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">State:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {pinDetail?.state}
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">City:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {pinDetail?.city}
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">Address:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {pinDetail?.address}
                        </h6>
                      </li>
                    </ul>
                  </Col>

                  {/* Right Column */}
                  <Col md={6} className="my-2">
                    <ul className="list-unstyled mb-0 notLastBorder ps-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">
                          Assigned To:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {pinDetail?.assignTo?.join(", ")}
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">Status:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          <Form.Check
                            type="switch"
                            id="pin-status"
                            checked={pinDetail?.status === "active"}
                            readOnly
                          />
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-start gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">
                          Description:
                        </p>
                        <p
                          className="m-0 text-muted w-50"
                          style={{ fontSize: 12, lineHeight: "18px" }}
                        >
                          {pinDetail?.description}
                        </p>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">
                          Created At:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {moment(pinDetail?.createdAt).format("YYYY-MM-DD")}
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-50">
                          Updated At:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {moment(pinDetail?.updatedAt).format("YYYY-MM-DD")}
                        </h6>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PinDetail;
